import {
  formatUnixDate,
  formatUnixDateTime,
  formatDate,
  daysDiff,
  yearsDiff,
  fromNow,
  formatLocaleShort,
  parseDate,
} from './dateUtils';
import { get, set } from 'lodash';

import Vue from 'vue';

String.format = function (format) {
    var args = Array.prototype.slice.call(arguments, 1);
    return format.replace(/{(\d+)}/g, function (match, number) {
        return typeof args[number] != 'undefined' ? args[number] : match;
    });
};


const FormatDate = Vue.filter('formatDate', function(value) {
    if (value) {
        if (typeof value === 'number') {
            return formatUnixDate(value);
        }
        const d = parseDate(value);
        return d ? formatDate(d, 'DD/MM/YYYY') : '';
    }
});

export const FormatDateTime = Vue.filter('formatDateTime', function(value) {
    if (value) {
        if (typeof value === 'number') {
            return formatUnixDateTime(value);
        }
        const d = parseDate(value);
        return d ? formatDate(d, 'DD/MM/YYYY HH:mm') : 'N/A';
    }
    return 'N/A';
});

export const FormatDateDays = Vue.filter('formatDateWithDays', function(value) {
    if (value) {
        const d = parseDate(value);
        if (!d) return '';
        const days = daysDiff(d, new Date());
        const date_format = formatDate(d, 'DD/MM/YYYY HH:mm');
        return `(${date_format}) - ${days} Days ago`;
    }
});

export const FormatDateDaysToGo = Vue.filter('formatDateWithDaysToGo', function(value) {
    if (value) {
        const d = parseDate(value);
        if (!d) return '';
        const days = daysDiff(new Date(), d);
        const date_format = formatDate(d, 'DD/MM/YYYY HH:mm');
        return `(${date_format}) - ${days} Days away`;
    }
});

export const FormatDateYears = Vue.filter('formatDateWithYears', function(value) {
    if (value) {
        const d = parseDate(value);
        if (!d) return '';
        const years = yearsDiff(d, new Date());
        const date_format = formatDate(d, 'DD/MM/YYYY HH:mm');
        return `(${date_format}) - ${years} Years old`;
    }
});

export const FormatDateFromNow = Vue.filter('formatDateFromNow', function(value) {
    if (value) {
        return fromNow(value);
    }
});

export const FormatTimestamp = Vue.filter('formatTimestamp', function(value) {
    if (value) {
        return formatLocaleShort(value);
    }
});

export const FormatImpactRisk = Vue.filter('formatRisk', function(value) {
    let lookup = {
        'critical': 'Critical',
        'high': 'High',
        'medium': 'Medium',
        'low': 'Low',
        'info': 'Info',
        'investigate': 'Investigate',
    };
    if (value) {
        let risk = value.substring(4);
        if (lookup[risk]) {
            return lookup[risk];
        } else {
            return 'Info';
        }
    }
});

export const FormatStatus = Vue.filter('formatStatus', function(value) {
    let lookup = {
        'unfixed': 'Unfixed',
        'confirmed': 'Confirmed',
        'fixed': 'Fixed',
        'false_positive': 'False Positive',
        'acceptable_risk': 'Acceptable Risk',
    };
    if (value) {
        if (lookup[value]) {
            return lookup[value];
        } else {
            return titleCase(value);
        }
    }
});

export const Truncate = Vue.filter('truncate', function (value, size) {
    if (!value) return '';
    value = value.toString();

    if (value.length <= size) {
        return value;
    }
    return value.substr(0, size) + '...';
});

export const titleCase = Vue.filter('title', function(value) {
    return value.toLowerCase().replace(/(?:^|\s|-)\S/g, x => x.toUpperCase());
});

export const createUUIDv4 = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

export const numberRangeCheck = (number, from, to) => {
    if (isNaN(number)) {
        number = from;
    } else if (number < from) {
        number = from;
    } else if (number > to) {
        number = to;
    }
    return number
}

export const isRestricted = (element, permissions) => {
    if (element.permissions && element.permissions.length > 0) {
        let isElementRestricted = true;
        if (permissions) {
            for (let index = 0; index < element.permissions.length; index++) {
                const elementPermission = element.permissions[index];
                const isUserPermission = permissions[elementPermission] === true;
                const isOrganisationPermission = permissions.organisation?.[elementPermission] === true;
                isElementRestricted = !(isUserPermission || isOrganisationPermission);
                if (!isElementRestricted) break;
            }
        }
        return isElementRestricted;
    }
    return false;
}

export const addFullMapping = (fields, mapping) => {
    /**
        Recursively adds a 'full_mapping' key to the schema
        fields - fieldset based on JSON schema
        mapping - key mapping
    **/

    var parent_mapping = mapping;
    mapping = "";

    fields.forEach((element) => {
        if (element.mapping) {
            if (parent_mapping) {
                mapping = parent_mapping + '.' + element.mapping;
            } else {
                mapping = element.mapping;
            }
        } else if (parent_mapping) {
            mapping = parent_mapping;
        } else {
            mapping = '';
        }

        if (element.tabs) {
            addFullMapping(element.tabs, mapping);
            return;
        }
        if (element.fields) {
            addFullMapping(element.fields, mapping);
            return;
        }

        if (mapping) {
            element["full_mapping"] = mapping;
        }

    });
};


export const regexEscape = (s) => String(s).replace(/[\\^$*+?.()|[\]{}]/g, '\\$&');

export const cleanHostName = (host) => {
    try {
        let hostItem = host.trim();
        if (!hostItem.startsWith('http://') && !hostItem.startsWith('https://')) {
            hostItem = `https://${hostItem}`;
        }
        const parsedUrl = new URL(hostItem);
        return parsedUrl.hostname;
    } catch (e) {
        return host;
    }
};

export const isEqual = (left, right) => {
    if (left === right) {
        return true;
    }

    if (left == null || right == null || typeof left !== typeof right) {
        return false;
    }

    if (Array.isArray(left) && Array.isArray(right)) {
        if (left.length !== right.length) {
            return false;
        }
        for (let i = 0; i < left.length; i++) {
            if (!isEqual(left[i], right[i])) {
                return false;
            }
        }
        return true;
    }

    if (left instanceof Set && right instanceof Set) {
        if (left.size !== right.size) {
            return false;
        }
        for (let item of left) {
            if (!right.has(item)) {
                return false;
            }
        }
        return true;
    }

    if (typeof left === 'object' && typeof right === 'object') {
        const keys1 = Object.keys(left);
        const keys2 = Object.keys(right);

        if (keys1.length !== keys2.length) {
            return false;
        }

        for (let key of keys1) {
            if (!keys2.includes(key) || !isEqual(left[key], right[key])) {
                return false;
            }
        }
        return true;
    }

    return false;
}


export const isIPAddress = (value) => {
    const ipRegex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    return ipRegex.test(value);
}

export const getWindowDimensions = () => {
    const clientW = document.documentElement.clientWidth;
    const clientH = document.documentElement.clientWidth;

    const width =  (window.innerWidth && clientW) ?
        Math.min(window.innerWidth, clientW) :
        (window.innerWidth || clientW || document.getElementsByTagName('body')[0].clientWidth);

    const height =  (window.innerHeight && clientH) ?
        Math.min(window.innerHeight, clientH) :
        (window.innerHeight || clientH || document.getElementsByTagName('body')[0].clientHeight);

    return {width, height}
}

export const delay = (ms = 400) => {
    return new Promise(resolve => setTimeout(resolve, ms))
};

export const toPascalCase = (str) => {
    return str
        .replace(/(^\w|[-_/]\w)/g, match => match.replace(/[-_/]/, '').toUpperCase())
}